
export class EqActionsVwMdl {
    public Id: number;
    public Type: ActionType;
    public TypeAsString: string;
    public Date: Date;
    public DateAsStr: string;
    public Cost: number;
    public Comment: string;
    public EquipmentId: number;
    public SystemId: number;
    public ComponentId: number;
    public SMU: number;
    public LTD: number;
    public recordStatus: number;
}

export enum ActionType {
    OldActionType = 1,
    Replace = 4,
    Weld = 2,
    TurnPinsAndBushingsLink = 9,
    RepairDryJointsLink = 8,
    AdjustTensionLink = 10,
    RepairDryJointsBush = 11,
    TurnPinsAndBushingsBush = 12,
    AdjustTensionBush = 13,
    Regrouser = 14,
    WeldTreads = 16,
    SwapFrontRear = 17,
    Reshell = 20,
    InsertInspection = 32,
    UpdateInspection = 33,
    ReplaceSystemFromInventory = 34,
    ReplaceComponentWithNew = 35,
    NoActionTakenYet = 36,
    EquipmentSetup = 37,
    InstallComponentOnSystemOnEquipment = 38,
    InstallSystemOnEquipment = 39,
    ChangeMeterUnit = 40,
    SMUReadingAction = 41,
    InsertInspectionGeneral = 42,
    UpdateInspectionGeneral = 43,
    UpdateSetupEquipment = 44,
    UpdateUndercarriageSetupOnEquipment = 45,
    GETAction = 99,




    // NewlyImplementedActions
    RelocateSystem = 200,
    ReplaceWithNewEqaliserBar = 10912
}
